import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './page/Home';
import ManagerLogin from './page/ManagerLogin';
import AdminSetupPage from './page/AdminSetupPage';
import AdminManagementPage from "./page/AdminManagementPage";
import StudentFinishedPage from './page/StudentFinishedPage';
import StudentInfoPage from './page/StudentInfoPage';
import FileManagementPage from './page/FileManagementPage';
import Header from './components/Header';
import SelectUser from './page/SelectUser';
import { AuthProvider } from './components/AuthContext';
import PrivateRoute  from './components/PrivateRoute';
import Survey from './page/Survey';
import Disruption from './page/Disruption';
//all of the page routes and links, added the select user as a new landing page 
// Sets up all the main routes and pages for the app
// Uses React Router to handle navigation between pages
// Wraps everything with AuthProvider to manage login sessions
// SelectUser is now the new landing page when users first visit
function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<SelectUser />} />
          <Route path="/studenthome" element={<Home />} />
          <Route path="/bm" element={<ManagerLogin />} />
          <Route path="/setup" element={<PrivateRoute element={<AdminSetupPage/>} />} />
          <Route path="/management" element={<PrivateRoute element={<AdminManagementPage />} />} />
          <Route path="/complete" element={<StudentFinishedPage />} />
          <Route path="/studentinfo" element={<StudentInfoPage />} />
          <Route path="/filemanagement" element={<PrivateRoute element={<FileManagementPage/>} />} />
          <Route path="/survey" element={<Survey/>} />
          <Route path="/disruption" element={<Disruption/>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;